import React from 'react';
import cn from 'classnames';
import type { FC, ReactElement } from 'react';

import styles from './DesignAlert.module.scss';

interface DesignAlertProps {
  show?: boolean;
  toggleShow: () => void;
}

export const DesignAlert: FC<DesignAlertProps> = ({ show, toggleShow }): ReactElement => (
  <div className={cn(styles.wrapper, show && styles.show)} role={'button'} onClick={toggleShow} />
);
